import React from 'react'
import ResetActiveShiftOnPipe from 'support/pipelines/pipes/ResetActiveShiftOnPipe'
import { OnNavigatePipeline, OnNavigateStartPipeline } from '@morningtrain/react-navigation'
import { ResetSmartviewOnPipe } from '@morningtrain/react-smartviews'

export default function NavigationPipelines (props) {
  return (
    <>
      <OnNavigatePipeline>
        <ResetActiveShiftOnPipe />
      </OnNavigatePipeline>
      <OnNavigateStartPipeline>
        <ResetSmartviewOnPipe />
      </OnNavigateStartPipeline>
    </>
  )
}
